// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `scoreboard-column {
  display: block;
  width: min(25vw, 100px);
  min-height: 150px;
}
scoreboard-column .wrapper {
  height: 100%;
  width: 100%;
  position: relative;
  border-radius: 5px;
  background-color: var(--motes-gray);
  overflow: hidden;
}
scoreboard-column .wrapper.loading {
  background: linear-gradient(-45deg, #979696, var(--motes-light-gray));
  background-size: 400% 400%;
  animation: gradient ease infinite;
}
scoreboard-column .column {
  position: absolute;
  bottom: 0;
  width: 100%;
  transform-origin: bottom;
  background-color: var(--motes-blue);
  animation: grow ease-out;
}
scoreboard-column .icon,
scoreboard-column .label,
scoreboard-column .score {
  position: absolute;
  width: 100%;
  margin: 0;
  font-size: 1.5em;
  text-align: center;
  color: var(--motes-white);
}
scoreboard-column .icon {
  font-size: 2em;
  opacity: 0;
  bottom: 50%;
  color: var(--motes-blue);
  animation: appear ease-in forwards;
}
scoreboard-column .label {
  bottom: 2em;
}
scoreboard-column .score {
  bottom: 0.5em;
}
scoreboard-column .highlight {
  color: var(--motes-dark);
}
scoreboard-column .highlight .column {
  background-color: var(--motes-highlight-color);
}
@keyframes grow {
  0% {
    transform: scaleY(0%);
  }
  100% {
    transform: scaleY(100%);
  }
}
@keyframes appear {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 100;
  }
}
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/scoreboard-column/scoreboard-column.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,uBAAA;EACA,iBAAA;AACF;AACE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,mCAAA;EACA,gBAAA;AACJ;AACI;EACE,qEAAA;EACA,0BAAA;EACA,iCAAA;AACN;AAGE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,wBAAA;EACA,mCAAA;EACA,wBAAA;AADJ;AAIE;;;EAGE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAFJ;AAKE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;EACA,kCAAA;AAHJ;AAME;EACE,WAAA;AAJJ;AAOE;EACE,aAAA;AALJ;AAQE;EACE,wBAAA;AANJ;AAOI;EACE,8CAAA;AALN;AASE;EACE;IACE,qBAAA;EAPJ;EASE;IACE,uBAAA;EAPJ;AACF;AAUE;EACE;IACE,UAAA;EARJ;EAUE;IACE,YAAA;EARJ;AACF;AAWE;EACE;IACE,2BAAA;EATJ;EAWE;IACE,6BAAA;EATJ;EAWE;IACE,2BAAA;EATJ;AACF","sourcesContent":["scoreboard-column {\n  display: block;\n  width: min(25vw, 100px);\n  min-height: 150px;\n\n  .wrapper {\n    height: 100%;\n    width: 100%;\n    position: relative;\n    border-radius: 5px;\n    background-color: var(--motes-gray);\n    overflow: hidden;\n\n    &.loading {\n      background: linear-gradient(-45deg, #979696, var(--motes-light-gray));\n      background-size: 400% 400%;\n      animation: gradient ease infinite;\n    }\n  }\n\n  .column {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    transform-origin: bottom;\n    background-color: var(--motes-blue);\n    animation: grow ease-out;\n  }\n\n  .icon,\n  .label,\n  .score {\n    position: absolute;\n    width: 100%;\n    margin: 0;\n    font-size: 1.5em;\n    text-align: center;\n    color: var(--motes-white);\n  }\n\n  .icon {\n    font-size: 2em;\n    opacity: 0;\n    bottom: 50%;\n    color: var(--motes-blue);\n    animation: appear ease-in forwards;\n  }\n\n  .label {\n    bottom: 2em;\n  }\n\n  .score {\n    bottom: 0.5em;\n  }\n\n  .highlight {\n    color: var(--motes-dark);\n    .column {\n      background-color: var(--motes-highlight-color);\n    }\n  }\n\n  @keyframes grow {\n    0% {\n      transform: scaleY(0%);\n    }\n    100% {\n      transform: scaleY(100%);\n    }\n  }\n\n  @keyframes appear {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 100;\n    }\n  }\n\n  @keyframes gradient {\n    0% {\n      background-position: 0% 50%;\n    }\n    50% {\n      background-position: 100% 50%;\n    }\n    100% {\n      background-position: 0% 50%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
